// Category names — must match the "category" value in each faction JSON exactly.
export const CATEGORIES = [
  "Forward Screen Units",
  "Vanguard Unit",
  "Main Column",
  "Additional Fire Support",
  "(Optional) Reinforcement Requests",
];

// The optional, toggleable reinforcements category.
export const REINFORCEMENT_CATEGORY = "(Optional) Reinforcement Requests";

// Section-level maximum number of units (roster lines) allowed per category.
export const SECTION_MAX_UNITS = {
  "Vanguard Unit": 1,
};

// Manifest of available factions — fetched live on app load.
export const ARMYLISTS_URL = "https://raw.githubusercontent.com/atpcummings-code/northag-data/refs/heads/main/armylists.json";

// Fallback faction sources — used only if the live armylists manifest fails to load.
export const DEFAULT_SOURCES = [
  { id: "uk-northag", name: "British Army of the Rhine (NORTHAG)", url: "https://raw.githubusercontent.com/atpcummings-code/northag-data/refs/heads/main/uk-northag.json" },
  { id: "de-centag", name: "Bundeswehr Panzerbrigade (CENTAG)", url: "https://raw.githubusercontent.com/atpcummings-code/northag-data/refs/heads/main/de-centag.json" },
  { id: "us-centag", name: "US Army V Corps (CENTAG)", url: "https://raw.githubusercontent.com/atpcummings-code/northag-data/refs/heads/main/us-centag.json" },
  { id: "su-northag", name: "Russian Armed Battlegroup (OPFOR)", url: "https://raw.githubusercontent.com/atpcummings-code/northag-data/refs/heads/main/su-northag.json" },
];

// Morale rating: JSON can use "C"/"P"/"E" or the full word, case-insensitive.
export const MORALE_MAP = {
  c: "Conscript", conscript: "Conscript",
  p: "Professional", professional: "Professional",
  e: "Elite", elite: "Elite",
};

export const MORALE_CLASS = {
  Conscript: "morale-c",
  Professional: "morale-p",
  Elite: "morale-e",
};
